<generic-message [messageDetails]="error"></generic-message>
